import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { redemptionDetailsFragment, redemptionFragment } from "./queries";
import {
  RedemptionCataloguesAdd,
  RedemptionCataloguesAddVariables
} from "./types/RedemptionCataloguesAdd";
import {
  RedemptionCataloguesRemove,
  RedemptionCataloguesRemoveVariables
} from "./types/RedemptionCataloguesRemove";
import { RedemptionCreateDefault } from "./types/RedemptionCreateDefault";
import {
  RedemptionReorderVariants,
  RedemptionReorderVariantsVariables
} from "./types/RedemptionReorderVariants";
import {
  RedemptionUpdate,
  RedemptionUpdateVariables
} from "./types/RedemptionUpdate";
import {
  RedemptionVariantUpdate,
  RedemptionVariantUpdateVariables
} from "./types/RedemptionVariantUpdate";

const redemptionCreateDefault = gql`
  ${redemptionFragment}
  mutation RedemptionCreateDefault {
    redemptionCreateDefault {
      redemption {
        ...RedemptionFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useRedemptionCreateDefaultMutation = makeMutation<
  RedemptionCreateDefault,
  null
>(redemptionCreateDefault);

const redemptionUpdate = gql`
  ${redemptionFragment}
  mutation RedemptionUpdate($id: ID!, $input: RedemptionInput!) {
    redemptionUpdate(id: $id, input: $input) {
      redemption {
        ...RedemptionFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useRedemptionUpdateMutation = makeMutation<
  RedemptionUpdate,
  RedemptionUpdateVariables
>(redemptionUpdate);

const redemptionVariantUpdate = gql`
  ${redemptionFragment}
  mutation RedemptionVariantUpdate(
    $redemptionId: ID!
    $variants: [RedemptionVariantInput]!
  ) {
    redemptionVariantUpdate(redemptionId: $redemptionId, variants: $variants) {
      redemption {
        ...RedemptionFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useRedemptionVariantUpdateMutation = makeMutation<
  RedemptionVariantUpdate,
  RedemptionVariantUpdateVariables
>(redemptionVariantUpdate);

const redemptionCataloguesRemove = gql`
  ${redemptionDetailsFragment}
  mutation RedemptionCataloguesRemove($input: CatalogueInput!, $id: ID!) {
    redemptionCataloguesRemove(id: $id, input: $input) {
      errors {
        field
        message
      }
      redemption {
        ...RedemptionDetailsFragment
      }
    }
  }
`;

export const useRedemptionCataloguesRemoveMutation = makeMutation<
  RedemptionCataloguesRemove,
  RedemptionCataloguesRemoveVariables
>(redemptionCataloguesRemove);

const redemptionCataloguesAdd = gql`
  ${redemptionDetailsFragment}
  mutation RedemptionCataloguesAdd($input: CatalogueInput!, $id: ID!) {
    redemptionCataloguesAdd(id: $id, input: $input) {
      errors {
        field
        message
      }
      redemption {
        ...RedemptionDetailsFragment
      }
    }
  }
`;

export const useRedemptionCataloguesAddMutation = makeMutation<
  RedemptionCataloguesAdd,
  RedemptionCataloguesAddVariables
>(redemptionCataloguesAdd);

const redemptionReorderVariants = gql`
  ${redemptionDetailsFragment}
  mutation RedemptionReorderVariants(
    $move: MoveRedemptionVariantInput!
    $redemptionId: ID!
  ) {
    redemptionReorderVariants(moves: [$move], redemptionId: $redemptionId) {
      redemption {
        ...RedemptionDetailsFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const useRedemptionReorderVariants = makeMutation<
  RedemptionReorderVariants,
  RedemptionReorderVariantsVariables
>(redemptionReorderVariants);
